module.exports = __webpack_public_path__ + "img/225.9d1275b4.png";